import React from 'react';

interface SkeletonProps {
  className?: string;
}

export default function Skeleton({ className = '' }: SkeletonProps): React.JSX.Element {
  return (
    <div className={`shimmer rounded-lg ${className}`} />
  );
}

export function CourseCardSkeleton(): React.JSX.Element {
  return (
    <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden shadow-sm">
      <Skeleton className="w-full h-48" />
      <div className="p-5 space-y-3">
        <Skeleton className="h-5 w-3/4" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-2/3" />
        <div className="flex items-center justify-between pt-2">
          <Skeleton className="h-5 w-20" />
          <Skeleton className="h-4 w-16" />
        </div>
      </div>
    </div>
  );
}

export function BannerSkeleton(): React.JSX.Element {
  return (
    <div className="flex-shrink-0 rounded-2xl overflow-hidden w-80 h-44">
      <Skeleton className="w-full h-full" />
    </div>
  );
}
